import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import SubscriptionPaywall, { EF_PRODUCTS } from './billing/SubscriptionPaywall';

interface PrivateRouteProps {
  redirectTo?: string;
  requiredRoles?: string | string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  redirectTo = '/landing',
  requiredRoles
}) => {
  const { user, loading } = useAuth();
  
  // Show loading spinner while Firebase initializes
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  // Only accept Firebase authenticated users
  if (!user) {
    // Clear any stale tokens on redirect to login
    localStorage.removeItem('auth_token');
    localStorage.removeItem('firebaseToken');
    return <Navigate to={redirectTo} replace />;
  }
  
  // User is authenticated — wrap in subscription paywall
  return (
    <SubscriptionPaywall
      product={EF_PRODUCTS['ef-crm']}
      getAuthToken={async () => {
        const token = await user.getIdToken();
        return token;
      }}
      userId={user.uid}
    >
      <Outlet />
    </SubscriptionPaywall>
  );
};

export default PrivateRoute; 